<div class="drawer-content">
  <mat-nav-list>
    <mat-accordion>
      <mat-expansion-panel
        *ngFor="let panel of filterLevelOneAccess()"
        [expanded]="tab === panel.tabUrl"
      >
        <mat-expansion-panel-header class="disable_ripple">
          <mat-panel-title>
            <mat-icon
              [ngClass]="panel.customClass ? panel.customClass : ''"
              mat-list-icon
              >{{ panel.tabIcon }}</mat-icon
            >
            <span class="drawer-style">{{ panel.tabTitle }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngFor="let item of filterLevelTwoAccess(panel.levelTwo)">
          <div
            [matTooltipDisabled]="!item.isDisabled"
            matTooltip="Under maintenance"
          >
            <mat-list-item
              [disabled]="item.isDisabled"
              [ngStyle]="
                item.isDisabled && {
                  background: '#616161E6'
                }
              "
              appAppDrawer
              routerLink="{{ item.url }}"
              routerLinkActive="active"
            >
              <mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
              <div class="title" mat-line>{{ item.title }}</div>
            </mat-list-item>
          </div>
        </ng-container>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-nav-list>
</div>
